import axios from "axios";
import Lockr from "lockr";
import {removeAuth} from '@/utils/auth'
import store from '@/store'
import router from '@/router'
import cache from '@/utils/cache'
import { Message, MessageBox } from 'element-ui';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

//配置
import xconfig from '@/config'
//當前可以提示的狀態嗎
let statusArr=['1001',"1002","1003","20007","1004","1005","1006","2002","2003","2008","40001","40002","40003","40004"]
//解码
let jGlobalSetting=''
if(process.env.NODE_ENV == 'production' && GlobalSetting){
    jGlobalSetting=JSON.parse(window.atob(GlobalSetting))
}

//多语种
import i18n from '@/utils/i18n'
let trueSit =true //是否本地sit
let truePrd =false //是否本地prd
let defaultAddress = trueSit?'http://mtrsrsmobile.test.cn-cic.com/CardAppService.svc':'https://mtrsrsmobileuat.hk-cic.com/CardAppService.svc'
if(truePrd){
    defaultAddress='https://mtrsrsmobile.hk-cic.com/CardAppService.svc'
}
window.BASE_URL = (process.env.NODE_ENV == 'development')?defaultAddress:jGlobalSetting.BASE_API
// window.BASE_URL='https://mtrsrsmobileuat.hk-cic.com/CardAppService.svc'
//window.BASE_URL='http://mtrsrsmobile.test.cn-cic.com/CardAppService.svc'

axios.defaults.headers['X-Content-Type-Options'] = 'nosniff'
axios.defaults.headers['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains';
axios.defaults.headers['X-XSS-Protection'] = '1'
axios.defaults.headers['Content-Security-Policy'] = "*"

//判断域名
if(window.BASE_URL && window.BASE_URL.indexOf('https://')!=-1){
    axios.defaults.headers['Content-Type'] = 'application/soap+xml; charset=utf-8'
    axios.defaults.headers['Accept'] = 'application/json;text/javascript;*/'
}else{
    axios.defaults.headers['Content-Type'] = 'text/xml; charset=utf-8'
    axios.defaults.headers['Accept'] = 'application/json;text/javascript;*/'
}

//xml转json
import x2js from 'x2js' //xml数据处理插件
import { unique } from "webpack-merge";
let xjson=new x2js()

//配置
const service = axios.create({
    baseURL: window.BASE_URL,
    timeout: 600000, // 请求超时时间
    responseType:'xml',
})

//请求拦截
service.interceptors.request.use(
    config=>{
        //判断
        let data=config.data
        let reqUrl=''
        //判断
        // console.log('data.reqUrl', data.reqUrl)
        if(data.reqUrl){
            reqUrl=data.reqUrl
        }else{
            console.warn('网络异常')
            source.cancel()
            Message({
                type:'error',
                message:i18n.$t('errorRequest')
            })
            return false
        }

        //判断
        if(reqUrl=='GetRuleInfoVJ'){
            config.baseURL=(process.env.NODE_ENV == 'development')?process.env.BASE_CV_API:jGlobalSetting.BASE_CV_API
        }

        //默认参数
        data.MasterSecret=xconfig.MasterSecret
        data.AppEstateId=xconfig.AppEstateId
        data.Version=xconfig.Version
        data.DeviceInfo=navigator.userAgent
        data.ClientType=xconfig.ClientType

        //判斷
        if(reqUrl=='GetElectronicQuestionList' || reqUrl=='DRManageApplicationDetail'){
            data.ClientType=33
        }
        data.Language=store.state.app.lang?cache.getLanuageId(store.state.app.lang):cache.getLanuageId(xconfig.Language)

        //判断
        if(data.reqUrl){
            reqUrl=data.reqUrl
        }else{
            console.warn('网络异常')
            source.cancel()
            Message({
                type:'error',
                message:i18n.$t('errorRequest')
            })
            return false
        }

        //判斷文件
        let fileurl=''
        if(data.fileurl){
            fileurl=data.fileurl
        }
        delete data.fileurl

        //无需登录
        if(data.isNoLogin){
            delete data.UserToken
            delete data.UserId
        }else{
            //默认参数
            data.UserToken=store.state.app.UserToken?store.state.app.UserToken:''
            data.UserId=store.state.app.UserId?store.state.app.UserId:''

            //判断参数
            if(!data.UserToken || !data.UserId){
                //判断
                source.cancel()
                router.push({path:'/login'})
                return false
            }
        }

        //判断
        let FilesData=data.hasOwnProperty('FilesData')?data.FilesData:null

        //删除公共参数
        delete data.reqUrl
        delete data.isNoLogin
        delete data.FilesData
        // console.log('data',data)

        //转成xml
        let xmlall=''
        if(window.BASE_URL && window.BASE_URL.indexOf('https://')!=-1){

            if(reqUrl=='UserUploadFile'||reqUrl=='ReportRepairUserUploadFile') {

                xmlall='<?xml version="1.0" encoding="utf-8"?><soap:Envelope xmlns:soap="http://www.w3.org/2003/05/soap-envelope" xmlns:tem="http://tempuri.org/"><soap:Header xmlns:wsa="http://www.w3.org/2005/08/addressing"><wsa:Action>http://tempuri.org/ICardAppService/'+reqUrl+'</wsa:Action><wsa:To>'+window.BASE_URL+'</wsa:To></soap:Header><soap:Body><tem:'+reqUrl+'><tem:JsonData><![CDATA['+JSON.stringify(data)+']]></tem:JsonData><tem:currentFileBytes><![CDATA['+fileurl+']]></tem:currentFileBytes>'+((FilesData)?('<tem:FilesData><![CDATA['+JSON.stringify(FilesData)+']]></tem:FilesData>'):'')+'</tem:'+reqUrl+'></soap:Body></soap:Envelope>'

            }else{
                xmlall='<?xml version="1.0" encoding="utf-8"?><soap:Envelope xmlns:soap="http://www.w3.org/2003/05/soap-envelope" xmlns:tem="http://tempuri.org/"><soap:Header xmlns:wsa="http://www.w3.org/2005/08/addressing"><wsa:Action>http://tempuri.org/ICardAppService/'+reqUrl+'</wsa:Action><wsa:To>'+window.BASE_URL+'</wsa:To></soap:Header><soap:Body><tem:'+reqUrl+'><tem:JsonData><![CDATA['+JSON.stringify(data)+']]></tem:JsonData>'+((FilesData)?('<tem:FilesData><![CDATA['+JSON.stringify(FilesData)+']]></tem:FilesData>'):'')+'</tem:'+reqUrl+'></soap:Body></soap:Envelope>'

            }
        }else{
            config.headers['SOAPAction']='http://tempuri.org/ICardAppService/'+reqUrl

            if( reqUrl=='UserUploadFile'||reqUrl=='ReportRepairUserUploadFile'){
                xmlall='<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema"><soap:Body><'+reqUrl+' xmlns="http://tempuri.org/"><JsonData><![CDATA['+JSON.stringify(data)+']]></JsonData><currentFileBytes><![CDATA['+fileurl+']]>'+'</currentFileBytes></'+reqUrl+'></soap:Body></soap:Envelope>'

            } else{
                xmlall='<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema"><soap:Body><'+reqUrl+' xmlns="http://tempuri.org/"><JsonData><![CDATA['+JSON.stringify(data)+']]></JsonData>'+((FilesData)?('<FilesData><![CDATA['+JSON.stringify(FilesData)+']]></FilesData>'):'')+'</'+reqUrl+'></soap:Body></soap:Envelope>'

                // xmlall='<v:Envelope xmlns:i="http://www.w3.org/2001/XMLSchema-instance" xmlns:d="http://www.w3.org/2001/XMLSchema" xmlns:c="http://schemas.xmlsoap.org/soap/encoding/" xmlns:v="http://schemas.xmlsoap.org/soap/envelope/"><v:Header /><v:Body><'+reqUrl+' xmlns="http://tempuri.org/" id="o0" c:root="1"><JsonData i:type="d:string">'+JSON.stringify(data)+'</JsonData></'+reqUrl+'></v:Body></v:Envelope>'
            }
            // xmlall='<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema"><soap:Body><'+reqUrl+' xmlns="http://tempuri.org/"><JsonData>'+JSON.stringify(data)+'</JsonData></'+reqUrl+'></soap:Body></soap:Envelope>'
        }

        //配置data
        config.data=xmlall
        config.reqUrl=reqUrl
        // console.log(config)

        // console.log('config', config.data)
        // debugger
        return config
    },
    error=>{
        console.warn('请求拦截错误',error)
    }
)

//返回拦截
service.interceptors.response.use(
    response=>{
        // console.log('response', response)
        //获取请求的参数
        let reqUrl=response.config.reqUrl
        const res = response.data

        //处理返回参数
        let jsonObj = xjson.xml2js(res)
        let fullPath=window.location.href
        fullPath=encodeURI(fullPath)

        //判断
        let StateList=null
        let ResultData=null
        // console.log("jsonObj.Envelope.Body[reqUrl+'Response'][reqUrl+'Result']", jsonObj.Envelope.Body[reqUrl+'Response'][reqUrl+'Result'])
        // console.log('jsonObj', jsonObj)

        if(jsonObj && jsonObj.Envelope.Body[reqUrl+'Response'][reqUrl+'Result']){
            //处理
            let xwcontent=jsonObj.Envelope.Body[reqUrl+'Response'][reqUrl+'Result']
            // console.log('xwcontent', xwcontent)
            ResultData=JSON.parse(xwcontent)
            if (!ResultData || !ResultData.StateList || ResultData.StateList.length == 0) {
            	console.warn('出错...');
            	reject();
            } else {
            	StateList = ResultData.StateList[0];
            }

        }else{
            console.warn('出错....');
            reject();
        }

        //判断
        switch(StateList.StateCode){
            //系统异常
            case 1002:
            case 20007:
            case 20009:
                console.warn('系统异常')
                console.log('StateList.StateMsg', StateList.StateMsg)
                if(document.getElementsByClassName('configNetErrorTip')&&document.getElementsByClassName('configNetErrorTip').length>0){
                    let allErrorTipArr = document.getElementsByClassName('configNetErrorTip')
                    for(var elIndex=0;elIndex<allErrorTipArr.length;elIndex++){
                        document.getElementsByClassName('configNetErrorTip')[elIndex].style.display='none'
                    }
                }
                Message({
                    customClass:'configNetErrorTip',
                    type:'error',
                    message:statusArr.includes(StateList.StateCode)? StateList.StateMsg :i18n.t('errorRequest')
                    // message:statusArr.includes(StateList.StateCode)?i18n.t('server_error_'+StateList.StateCode):i18n.t('errorRequest')
                })
                source.cancel()
                break
            case 40004:
                console.warn('該賬戶密碼已被更改，請重新登入')
                MessageBox({
                    message:i18n.t('passwordisChange'),
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    confirmButtonText:i18n.t('confirm'),
                    callback:action=>{
                        removeAuth()
                        router.push({path:'/login'})
                    }
                })
                source.cancel()
                break
            //账号已在其它设备登入
            case 1004:
                console.warn('账号已在其它设备登入')
                Message({
                    type:'error',
                    message:statusArr.includes(StateList.StateCode)?i18n.t('server_error_'+StateList.StateCode):i18n.t('errorRequest')
                })
                source.cancel()
                break
            //没有该功能的权限
            case 1005:
                console.warn('没有该功能的权限')
                Message({
                    type:'error',
                    message:statusArr.includes(StateList.StateCode)?i18n.t('server_error_'+StateList.StateCode):i18n.t('errorRequest')
                })
                source.cancel()
                break
            //用户不存在或已失效
            case 1006:
                console.warn('用户不存在或已失效')
                MessageBox({
                    message:i18n.t('accoundInvalid'),
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    confirmButtonText:i18n.t('confirm'),
                    callback:action=>{
                        removeAuth()
                        router.push({path:'/login'})
                    }
                })
                source.cancel()
                break
            //数据异常
            case 2001:
                console.warn('数据异常')
                Message({
                    type:'error',
                    message:i18n.t('errorRequest')
                })
                return Promise.reject(res)
                break
            //未找到
            case 2002:
                let remessage=''
                if(reqUrl=='GetNoticeContent' || reqUrl=='GetNoticeContentByGuid'||reqUrl=='GetNoticeClassList'){
                    remessage=i18n.t('noGetNoticeContent')
                }else{
                    remessage=statusArr.includes(StateList.StateCode)?i18n.t('server_error_'+StateList.StateCode):i18n.t('errorRequest')
                }
                Message({
                    type:'error',
                    message:remessage,
                    duration:2000,
                    onClose:function(){
                        router.back()
                    }
                })
                return Promise.reject(res)
                break
            //正常
            case 1001:
            case 2003:
                //验证返回数据
                // console.log(ResultData)
                return ResultData
                break;
            default:
                console.warn('res.Code不存在')
                if(statusArr.includes(StateList.StateCode+'')){
                    Message({
                        type:'error',
                        message:statusArr.includes(StateList.StateCode+'')?i18n.t('server_error_'+StateList.StateCode):i18n.t('errorRequest')
                    })
                }else{
                    Message({
                        type:'error',
                        message:i18n.t('errorRequest')
                    })
                    return Promise.reject(res)
                }
                 //return Promise.reject(res)
                break
        }

        return response
    },
    error => {
        console.warn('返回拦截错误',error)
        let errormessage=i18n.t('errorRequest')
        if (error.response) {
            const response = error.response
            if (response.status == 500) {
                errormessage=i18n.t('errorRequest')
            } else if (response.data && response.data.msg) {
                errormessage=response.data.msg
            }
        }

        if(reqUrl!='OperateInboxMsg'){
            Message({
                type:'error',
                message:errormessage
            })
        }

        return Promise.reject(error)
    }
)

//过滤
function transSpecial(theString){
    if(theString!=undefined && theString!="" && theString!='null'){
        // theString = theString.replace(">", "&gt;");
        // theString = theString.replace("<", "&lt;");
        // theString = theString.replace(" ", "&nbsp;");
        theString = theString.replace(/\\\"/g, "&quot;");
        // theString = theString.replace("\'", "&#39;");
        // theString = theString.replace("\\", "\\\\");//对斜线的转义
        theString = theString.replace(/\\n/g, "");
        theString = theString.replace(/\\r/g, " ");
        theString = theString.replace(/\\t/g, " ");
        // theString = theString.replace(/: \"/g, ":&quot;");
        // theString = theString.replace(/\";/g, "&quot;");
        // theString = theString.replace(/\",/g, "'");
        // theString = theString.replace("\r", "\\r");
        // theString=theString.replace(/\"/g, '\\\"')
    }
    return theString
}

export default service



// WEBPACK FOOTER //
// ./src/api/index.js